/* document */
import { BlockLabel } from './BlockLabel.js';

export const InfosArchive = (props) => {
    const datas = props.datas;
    return (
        datas.map((a,i) => {
            return (
                <div className="list" key={i}>
                    <BlockLabel label="Categorie" icon="fa fa-cogs" name={a.cname} />
                </div>
            )
        })
    )
}


